import React,{useEffect,useState,useReducer} from 'react'
import Categories from './Categories1'
import {Sliderdetails} from './Fetcher'




 const BannerSlider = [
        { id: 1,
         title: "Iphone 14 PRO",
         discription:"Apple Product",
         discount:"40% Discount & Support",
        price:"Starting from $299-$300",
        img:"img-slider.webp"},

         { id: 2,
         title: "HP Notebook R345",
         discription:"HP Product",
         discount:"10% Discount & Support",
         price:"Starting from $1299-$3000",
         img:"laptop.png"},
          { 
            id: 3,
         title: "Watch Ultra",
         discription:"Apple Product",
         discount:"30% Discount & Support",
         price:"Starting from $99-$300",
         img:"Watch Ultra.png"}
         
]

const Slider = () => {

  const [currentIndex, setCurrentIndex] = useState(0);


    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % BannerSlider.length);
      }, 3000); // Change slide every 3 seconds
  
      return () => clearInterval(interval);
    }, [BannerSlider.length]);
  
  
  return (
    < >
   { 
   BannerSlider.map((data,index)=>{
 return <div key={index} 
className={`slide ${index === currentIndex ? 'active' : ''}`} >
    <div id='home'>
    <div id='slider-text'>
    <h1>{data.title} </h1>
    <p> {data.discription}</p>
    <h2> {data.discount}</h2>
    <h4>{data.price}</h4>
    {/* <button> Shop Today</button> */}
</div>

<div id='slider-img-wrapper'>
<img src={ `/asset/${data.img}`}/>
</div>


  </div>
  </div>
   })
    
   }
    
  </>
  )
}

export default Slider